import styles from './RmCardsGroupSeries.module.scss';
import SeriesContainer from './SeriesContainer';
import TitleAndLegendBar from './TitleAndLegendBar';
import legendIconGreen from './images/green-circle-icon.svg';
import infoIcon from 'assets/images/info-icon.svg';
import legendIconOrange from './images/orange-circle-icon.svg';
import legendIconRed from './images/red-circle-icon.svg';
import darkInfoIcon from 'assets/images/dark-info-icon.svg';
import { useState } from 'react';
import PropTypes from 'prop-types';

const RmCardsGroupSeries = (props) => {
    const {
        seriesTitle,
        minorThreshold,
        majorThreshold,
        cardsDataArray,
        navigateTo
    } = props;
    const [iconHoveredCount, setIconIsHoveredCount] = useState(0);
    const [iconIsHovered, setIconIsHovered] = useState(false);
    const renderLegend = () => (
        <>
            <div className={styles.shortLegendContainer}>
                <img
                    src={legendIconRed}
                    alt={''}
                    className={styles.legendIcon}
                />
                <div className={styles.legendText}>
                    <span>Major</span>
                    {iconHoveredCount > 0 && (
                        <span
                            className={
                                iconIsHovered ? styles.fadeIn : styles.fadeOut
                            }
                        >
                            {' '}
                            {`\u2265 ${majorThreshold}`}
                        </span>
                    )}
                </div>
            </div>

            <div className={styles.legendContainer}>
                <img
                    src={legendIconOrange}
                    alt={''}
                    className={styles.legendIcon}
                />
                <span className={styles.legendText}>
                    <span>Moderate</span>
                    {iconHoveredCount > 0 && (
                        <span
                            className={
                                iconIsHovered ? styles.fadeIn : styles.fadeOut
                            }
                        >
                            {' '}
                            {`${minorThreshold + 1} - ${majorThreshold - 1}`}
                        </span>
                    )}
                </span>
            </div>

            <div className={styles.shortLegendContainer}>
                <img
                    src={legendIconGreen}
                    alt={''}
                    className={styles.legendIcon}
                />
                <span className={styles.legendText}>
                    <span>Minor</span>
                    {iconHoveredCount > 0 && (
                        <span
                            className={
                                iconIsHovered ? styles.fadeIn : styles.fadeOut
                            }
                        >
                            {' '}
                            {`\u2264 ${minorThreshold}`}
                        </span>
                    )}
                </span>
            </div>
            <div
                className={styles.iconContainer}
                onMouseOver={() => {
                    setIconIsHovered(true);
                    setIconIsHoveredCount(iconHoveredCount + 1);
                }}
                onMouseOut={() => setIconIsHovered(false)}
            >
                <img src={iconIsHovered ? darkInfoIcon : infoIcon} alt={''} />
            </div>
        </>
    );
    return (
        <div className={styles.wrapper}>
            <TitleAndLegendBar title={seriesTitle} legend={renderLegend()} />
            <SeriesContainer
                cardsDataArray={cardsDataArray}
                navigateTo={navigateTo}
            />
        </div>
    );
};

RmCardsGroupSeries.propTypes = {
    seriesTitle: PropTypes.string,
    minorThreshold: PropTypes.number,
    majorThreshold: PropTypes.number,
    cardsDataArray: PropTypes.arrayOf(
        PropTypes.shape({
            titleOne: PropTypes.string.isRequired,
            titleTwo: PropTypes.string.isRequired,
            subTitleOne: PropTypes.string.isRequired,
            subTitleTwo: PropTypes.string.isRequired,
            upperRightContentOne: PropTypes.element,
            upperRightContentTwo: PropTypes.element,
            footerOne: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
                .isRequired,
            footerTwo: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
                .isRequired,
            groupOneData: PropTypes.any,
            groupTwoData: PropTypes.any,
            groupOneTooltipType: PropTypes.oneOf([
                'default',
                'scoreDecomposition',
                'trendAnalysis'
            ]),
            groupTwoTooltipType: PropTypes.oneOf([
                'default',
                'scoreDecomposition',
                'trendAnalysis'
            ]),
            groupOneDataType: PropTypes.oneOf([
                'default',
                'topFiveRms',
                'topFiveEmergingModerateRm',
                'topFiveEmergingMajorRm',
                'topFiveRmsSpike',
                'alerts'
            ]),
            groupTwoDataType: PropTypes.oneOf([
                'default',
                'topFiveRms',
                'topFiveEmergingModerateRm',
                'topFiveEmergingMajorRm',
                'topFiveRmsSpike',
                'alerts'
            ]),
            isBottomGroup: PropTypes.bool
        })
    ),
    navigateTo: PropTypes.func
};

export default RmCardsGroupSeries;
